<template>
  <page-wrapper v-if="!ctxLoading">
    <warning-message :text="t('ngp/async_component_error')" />
  </page-wrapper>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useServiceStore } from "../../store/service";
import PageWrapper from "../layout/PageWrapper.vue";
import WarningMessage from "../util/WarningMessage.vue";

const { t } = useI18n();
const service = useServiceStore();
const ctxLoading = computed(() => service.isLoading);
</script>
